// Agent mapping configuration for TARA analysis steps
// Based on the actual agent order from the backend supervisor service (ISO 21434 order)
export const AGENT_MAPPING = {
  1: {
    primary: 'analysis_agent',
    review: 'analysis_review_agent',
    name: 'Item Definition',
    description: 'Define system scope and boundaries'
  },
  2: {
    primary: 'asset_identification_agent',
    review: 'asset_identification_review_agent',
    name: 'Asset Identification',
    description: 'Identify and classify cybersecurity assets'
  },
  3: {
    primary: 'damage_scenario_agent',
    review: 'damage_scenario_review_agent',
    name: 'Damage Scenarios',
    description: 'Assess potential damage scenarios from asset compromise'
  },
  4: {
    primary: 'threat_analysis_agent',
    review: 'threat_analysis_review_agent',
    name: 'Threat Analysis',
    description: 'Identify threats that could cause damage scenarios'
  },
  5: {
    primary: 'attack_path_feasibility_agent',
    review: 'attack_path_feasibility_review_agent',
    name: 'Attack Path Feasibility',
    description: 'Analyze attack path feasibility'
  },
  6: {
    primary: 'risk_assessment_agent',
    review: 'risk_assessment_review_agent',
    name: 'Risk Assessment',
    description: 'Assess overall risk levels'
  },
  7: {
    primary: 'cybersecurity_goals_agent',
    review: 'cybersecurity_goals_review_agent',
    name: 'Cybersecurity Goals',
    description: 'Generate cybersecurity goals (Reduce) and claims (Share/Retain)'
  },
  8: {
    primary: 'cybersecurity_concept_agent',
    review: 'cybersecurity_concept_review_agent',
    name: 'Cybersecurity Concept',
    description: 'Generate controls and requirements'
  },
  9: {
    primary: 'final_report_agent',
    review: 'final_report_review_agent',
    name: 'Final Report',
    description: 'Generate final TARA report'
  },
  10: {
    primary: 'control_implementation',
    review: null, // No review agent for residual TARA
    name: 'Residual TARA',
    description: 'Control implementation, requirements evaluation, and residual risk analysis (ISO 21434 Phase 2)'
  }
};

// Helper function to get agent name for a specific step and type
export const getAgentName = (step, type = 'primary') => {
  const stepConfig = AGENT_MAPPING[step];
  if (!stepConfig) {
    console.warn(`No agent mapping found for step ${step}`);
    return null;
  }

  return stepConfig[type] || null;
};

// Helper function to get step configuration
export const getStepConfig = (step) => {
  return AGENT_MAPPING[step] || null;
};

// Helper function to get all agent names in order
export const getAllAgentNames = () => {
  return Object.values(AGENT_MAPPING).map(config => config.primary);
};

// Helper function to get agent order for a specific step
export const getAgentOrder = (step) => {
  return step; // The step number corresponds to the agent order
};
